import ActionProvider from '../store/schema/ActionProvider';
import * as Adaptive from 'adaptivecards';

export default function setHostCapabilitiesOnHostConfig(
    hostConfig: Adaptive.HostConfig,
    actionProviders: ActionProvider[]
) {
    const hostCapabilities: Adaptive.HostCapabilityMap = {};
    actionProviders.forEach(actionProvider => {
        if (actionProvider?.registerHostCapabilities) {
            actionProvider.registerHostCapabilities(hostCapabilities);
        }
    });
    hostConfig.hostCapabilities.capabilities = hostCapabilities;
}
